import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_EQUITY_STOCK } from "@helpers/constants";

export class EquityStockWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_EQUITY_STOCK;
}
